import { render, staticRenderFns } from "./SettingsMediaCropper.vue?vue&type=template&id=338afa8a&"
import script from "./SettingsMediaCropper.vue?vue&type=script&lang=js&"
export * from "./SettingsMediaCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338afa8a')) {
      api.createRecord('338afa8a', component.options)
    } else {
      api.reload('338afa8a', component.options)
    }
    module.hot.accept("./SettingsMediaCropper.vue?vue&type=template&id=338afa8a&", function () {
      api.rerender('338afa8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsMediaCropper.vue"
export default component.exports